/** Brush edges at or under this alpha are not part of the mask (the Lab Playground's threshold) */
export const LAB_MASK_ALPHA_THRESHOLD = 100

/**
 * The Lab eraser's mask contract (lab-back gen-worker `_read_mask`, the Lab Playground's `exportMask`): a PNG whose
 * alpha marks what to erase — white on transparent, binary, at the input image's size. The worker reads only the
 * alpha channel of an RGBA PNG, so the opaque black background of the ai-visuals (Propershot) export would mark the
 * whole photo. Rewrites RGBA pixels in place and reports whether anything is marked: an empty mask fails the order.
 */
export const binarizeLabMaskPixels = (pixels: Uint8ClampedArray): boolean => {
  let isMarked = false
  for (let index = 0; index < pixels.length; index += 4) {
    const isOn = pixels[index + 3] > LAB_MASK_ALPHA_THRESHOLD
    pixels[index] = 255
    pixels[index + 1] = 255
    pixels[index + 2] = 255
    pixels[index + 3] = isOn ? 255 : 0
    isMarked = isMarked || isOn
  }
  return isMarked
}
